import { CSDT, CSSC, CSST } from '../types';

const initialState = {
  client: null,
  token: null,
};

const crossStorage = (state = initialState, action) => {
  switch (action.type) {
    case CSSC:
      return { ...state, client: action.client };
    case CSST:
      return { ...state, token: action.token };
    case CSDT:
      return { ...state, token: null };
    default:
      return state;
  }
};

export { crossStorage };
